/**
 * @typedef {Object} PulseEventDto
 * @property {number} eventId
 * @property {string} eventType
 * @property {number} [productionOrderId]
 * @property {string} [orderNumber]
 * @property {number} [wipItemId]
 * @property {string} [itemNumber]
 * @property {number} [executionId]
 * @property {string} [stepName]
 * @property {string} [stationName]
 * @property {string} [userName]
 * @property {string} eventTime
 * @property {string} [summary]
 */

/**
 * @typedef {Object} PulseEventListResponse
 * @property {PulseEventDto[]} items
 * @property {number} totalCount
 */

const BASE_PATH = 'v1/Events';

export default function (instance) {
  return {
    getRecentEvents(take = 20) {
      return instance.get(BASE_PATH, { params: { take } });
    },
    getPagedEvents(page = 1, pageSize = 20) {
      return instance.get(`${BASE_PATH}/paged`, { params: { page, pageSize } });
    }
  };
}
